/* PATCH 19/10/2026 — pulsante «Chiedi all'IA» (Brand Agent, shadow DOM #ads-agent-host) su mobile.
   Non si nasconde mai: su <=767px diventa icona 44px (su desktop resta con etichetta, spostato in basso a sinistra). Con la barra d'acquisto visibile occupa lo slot
   della miniatura DENTRO la barra (non copre prezzo, IVA, «Aggiungi»); senza barra resta a destra sopra il badge privacy (stesso slot di prima). Il widget riscrive i propri stili inline: li ri-applichiamo con un osservatore.
   Fail-open: se il markup del widget cambia non succede nulla. Rollback: BACKUP/ in _state/shopify/PATCH_PULSANTE_IA_20261019. */
(function () {
  'use strict';
  var MQ = 767, SIZE = 44, STYLE_ID = 'gef-pill-bar-style';
  var CSS =
    '[data-testid=entrypoint]>button{display:none!important}' +
    '[data-testid=entrypoint] .entrypoint-shadow{max-width:none!important}' +
    '[data-testid=entrypoint] .entrypoint-shadow>div:first-child{padding:0!important;gap:0!important;background:#101210!important}' +
    '[data-testid=entrypoint] .entrypoint-shadow>div:first-child>div:first-child{width:40px!important;height:40px!important}' +
    '[data-testid=entrypoint] .entrypoint-shadow>div:first-child>div:last-child{display:none!important}' +
    '[data-testid=entrypoint] .entrypoint-shadow .agent-avatar-bg{background:#101210!important}';
  var obsEntry = null, obsRoot = null, curEntry = null, raf = 0, retry = 0;

  function mobile() { return window.innerWidth <= MQ; }
  function barState() {
    var bar = document.querySelector('[data-gef-cd-sticky-mobile]');
    if (!bar) return null;
    var on = bar.classList.contains('is-visible') && !bar.classList.contains('is-hidden-by-scroll') && !bar.hasAttribute('data-sticky-hidden');
    return { bar: bar, on: on, h: bar.offsetHeight || 54 };
  }
  function setI(el, p, v) {
    if (el.style.getPropertyValue(p) === v && el.style.getPropertyPriority(p) === 'important') return;
    el.style.setProperty(p, v, 'important');
  }
    function apply() {
    var host = document.querySelector('#ads-agent-host');
    var sr = host && host.shadowRoot;
    if (!sr) return false;
    var entry = sr.querySelector('[data-testid="entrypoint"]');
    if (!entry) return false;
    var st = sr.getElementById ? sr.getElementById(STYLE_ID) : null;
    if (!mobile()) {
      /* desktop: il pulsante resta com'e' (con etichetta) ma si sposta in basso a sinistra, a destra del badge privacy,
         cosi' non passa piu' sopra le righe di quantita'/prezzo della colonna acquisto */
      if (st) st.remove();
      document.body.classList.remove('gef-pill-active');
      entry.setAttribute('data-gef-pill', 'desktop');
      setI(entry, 'left', '76px'); setI(entry, 'right', 'auto'); setI(entry, 'bottom', 'calc(16px + var(--gef-dsk-base, 0px))');
      setI(entry, 'margin', '0'); setI(entry, 'transform', 'none'); setI(entry, 'translate', 'none');
      if (entry !== curEntry) {
        curEntry = entry;
        if (obsEntry) obsEntry.disconnect();
        obsEntry = new MutationObserver(schedule);
        obsEntry.observe(entry, { attributes: true, attributeFilter: ['style'] });
      }
      return true;
    }
    if (!st) { st = document.createElement('style'); st.id = STYLE_ID; st.textContent = CSS; sr.appendChild(st); }
    entry.setAttribute('data-gef-pill', '1');
    var s = barState();
    var inBar = !!(s && s.on);
    document.body.classList.add('gef-pill-active');
    var left, bottom;
    if (inBar) {
      left = 'calc(max(10px, env(safe-area-inset-left, 0px)) + 10px)';
      bottom = 'calc(max(10px, env(safe-area-inset-bottom, 0px)) + ' + Math.max(0, (s.h - SIZE) / 2) + 'px)';
    } else {
      /* nessuna barra visibile: icona 44px a destra, nello slot sopra il badge privacy (come oggi), senza teaser */
      left = 'auto';
      bottom = 'calc(var(--gef-fab-base,0px) + 56px)';
    }
    setI(entry, 'left', left); setI(entry, 'right', inBar ? 'auto' : '12px'); setI(entry, 'bottom', bottom);
    setI(entry, 'margin', '0'); setI(entry, 'transform', 'none'); setI(entry, 'translate', 'none');
    setI(entry, 'z-index', '210'); setI(entry, 'transition', 'left .2s ease,bottom .2s ease');
    if (entry !== curEntry) {
      curEntry = entry;
      if (obsEntry) obsEntry.disconnect();
      obsEntry = new MutationObserver(schedule);
      obsEntry.observe(entry, { attributes: true, attributeFilter: ['style'] });
    }
    return true;
  }
  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () { raf = 0; apply(); });
  }
  function boot() {
    if (!apply()) {
      if (retry++ < 40) window.setTimeout(boot, 250);
      return;
    }
    var sr = document.querySelector('#ads-agent-host').shadowRoot;
    if (!obsRoot) { obsRoot = new MutationObserver(schedule); obsRoot.observe(sr, { childList: true, subtree: true }); }
  }
  var bar = document.querySelector('[data-gef-cd-sticky-mobile]');
  if (bar) {
    new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['class', 'data-sticky-hidden'] });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(bar);
  }
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);
  boot();
})();

(function () {
  'use strict';

  var bar = document.querySelector('[data-gef-cd-sticky-mobile]');
  if (!bar) return;

  document.body.classList.add('gef-cd-has-sticky-mobile');
  function addLabel() { return window.innerWidth >= 1024 ? 'Aggiungi al carrello' : 'Aggiungi'; }

  /* D55.2-bis 19/10/2026 — desktop: altezza del banner cookie in --gef-dsk-base, cosi' barra, WhatsApp e pulsante IA stanno SOPRA il banner
     e non coprono il prezzo. Fail-open: senza banner = 0. */
  (function () {
    var root = document.documentElement, last = -1, n = 0;
    function tick() {
      var h = 0;
      if (window.innerWidth >= 1024) {
        var cb = document.querySelector('#iubenda-cs-banner.iubenda-cs-visible');
        if (cb) { var r = cb.getBoundingClientRect(); if (r.height > 0 && r.top < window.innerHeight) h = Math.max(0, Math.round(window.innerHeight - r.top)); }
      }
      if (h !== last) { last = h; root.style.setProperty('--gef-dsk-base', h + 'px'); }
    }
    tick();
    var iv = window.setInterval(function () { tick(); if (++n > 900) window.clearInterval(iv); }, 600);
    window.addEventListener('resize', tick, { passive: true });
  })();

  var pdpRoot = document.querySelector('[data-pdp-root]');
  var vatMultiplier = pdpRoot ? parseFloat(pdpRoot.getAttribute('data-pdp-vat-multiplier')) : 1.22;
  var priceMode = bar.getAttribute('data-price-mode') || (pdpRoot && pdpRoot.getAttribute('data-price-mode')) || 'excl';
  if (!vatMultiplier || vatMultiplier < 1) vatMultiplier = 1.22;

  var cta = bar.querySelector('[data-sticky-cta]');
  var mainForm = document.querySelector('#gef-cd-pdp-form') ||
    document.querySelector('form[action*="/cart/add"]');
  var pricehead = document.querySelector('[data-bulk-pricehead]') ||
    document.querySelector('.gef-cd-pdp__cta-row') ||
    document.querySelector('.gef-cd-pdp__info');
  var shouldBeVisible = false;
  var lastY = window.scrollY || 0;
  var ticking = false;
  var agentSyncTimer = 0;
  var agentSyncAttempts = 0;

  /*
   * The Microsoft Brand Agent launcher lives in an open shadow root. Keep it
   * available on mobile PDPs, but lift it above the sticky cart only while the
   * cart is visible. Fail open if Microsoft changes its internal markup.
   */
  function positionBrandAgentLauncher() {
    if (window.innerWidth > 767) return true;
    var host = document.querySelector('#ads-agent-host');
    if (!host || !host.shadowRoot) return false;
    var launcher = host.shadowRoot.querySelector('[class~="fixed"][class~="bottom-0"][class~="right-0"]');
    if (!launcher) return false;
    launcher.style.setProperty('bottom', shouldBeVisible ? '96px' : '0px', 'important');
    return true;
  }

  function scheduleBrandAgentPosition() {
    if (window.innerWidth > 767) return;
    window.clearTimeout(agentSyncTimer);
    if (positionBrandAgentLauncher()) {
      agentSyncAttempts = 0;
      return;
    }
    if (agentSyncAttempts >= 24) return;
    agentSyncAttempts += 1;
    agentSyncTimer = window.setTimeout(scheduleBrandAgentPosition, 250);
  }

  function setVisible(vis) {
    shouldBeVisible = !!vis;
    bar.setAttribute('aria-hidden', shouldBeVisible ? 'false' : 'true');
    bar.classList.toggle('is-visible', shouldBeVisible);
    scheduleBrandAgentPosition();
  }

  function setDirectionState() {
    var y = window.scrollY || 0;
    lastY = y;
    if (!shouldBeVisible) return;
    if (y > 160) bar.classList.remove('is-hidden-by-scroll');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      setDirectionState();
    });
  }

  if ('IntersectionObserver' in window && pricehead) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting);
        if (entry.isIntersecting) bar.classList.remove('is-hidden-by-scroll');
      });
    }, { rootMargin: '-96px 0px -42% 0px', threshold: 0.01 }).observe(pricehead);
  } else {
    setVisible(true);
  }

  scheduleBrandAgentPosition();

  window.addEventListener('scroll', onScroll, { passive: true });

  var syncStickyState = function () {};
  var stickyVariantAvailable = cta ? !cta.disabled : true;

  function syncCtaQuoteState(isQuote) {
    if (!cta) return;
    cta.classList.toggle('is-quote', !!isQuote);
    cta.setAttribute('data-quote-active', isQuote ? 'true' : 'false');
    cta.setAttribute('aria-label', isQuote ? 'Richiedi preventivo' : 'Aggiungi al carrello');
    cta.textContent = isQuote ? 'Preventivo' : addLabel();
    syncStickyState();
  }

  if (cta && mainForm) {
    var mainAdd = mainForm.querySelector('[data-pdp-add-button]') || mainForm.querySelector('button[type="submit"]');
    /* UX PATCH 22/09: nasconde la sticky quando il cliente digita nel gate professionale.
       focusin su input dentro [data-pro-gate] → bar translateY(120%) + pointer-events none.
       focusout → ripristina dopo 300ms. scroll-margin-bottom sui campi gate.
       La checkbox e il testo di aiuto restano sempre visibili. */
    var gateRootEl = mainForm.querySelector('[data-pro-gate]');
    var uxHideTimer = null;
    if (gateRootEl) {
      mainForm.addEventListener('focusin', function (e) {
        if (!gateRootEl.contains(e.target)) return;
        if (uxHideTimer) { window.clearTimeout(uxHideTimer); uxHideTimer = null; }
        bar.setAttribute('data-sticky-hidden', 'true');
      });
      mainForm.addEventListener('focusout', function (e) {
        if (!gateRootEl.contains(e.target)) return;
        if (uxHideTimer) window.clearTimeout(uxHideTimer);
        uxHideTimer = window.setTimeout(function () {
          var active = document.activeElement;
          if (!active || !gateRootEl.contains(active)) {
            bar.removeAttribute('data-sticky-hidden');
          }
        }, 300);
      });
    }
    /* CSS inline: transizione sticky + scroll-margin-bottom campi gate */
    var uxStyle = document.createElement('style');
    uxStyle.textContent = '[data-gef-cd-sticky-mobile]{transition:transform 200ms ease-in-out}[data-gef-cd-sticky-mobile][data-sticky-hidden]{transform:translateY(120%)!important;pointer-events:none}.gef-cd-pdp__form [data-pro-gate] input,.gef-cd-pdp__form [data-pro-gate] select{scroll-margin-bottom:calc(72px + 16px)}';
    document.head.appendChild(uxStyle);
    var origLabel = cta.textContent;           /* catturato PRIMA di qualunque modifica */
    var origAria = cta.getAttribute('aria-label');
    /* FIX 21/09 P0 v3 — causalita' (MDN): requestSubmit() esegue la constraint validation
       PRIMA di emettere submit; con la checkbox del gate non spuntata la validazione
       blocca e l'utente vede solo un messaggio generico senza guida. Lo sticky legge lo
       STATO REALE (dataset del gate, qualifica corrente, campi VISIBILI) e guida al
       campo mancante. Il gate resta vincolante; nessun aggiramento. */
    function gateRoot(){ return mainForm.querySelector('[data-pro-gate]'); }
    function gateIncomplete(){
      return !!(gateRoot() && (!mainAdd || mainAdd.dataset.proGateComplete !== 'true'));
    }
    function visibile(el){ return !!(el && (el.offsetParent !== null || el === document.activeElement)); }
    function qualificaCorrente(){
      var r = gateRoot() && gateRoot().querySelector('[data-pro-gate-type-radio]:checked');
      return r ? r.value : 'piva';
    }
    function campoMancante(){
      var root = gateRoot();
      if (!root) return null;
      var t = qualificaCorrente();
      var candidato = null;
      if (t === 'albo') {
        var n = root.querySelector('[data-pro-gate-albo-num]');
        if (n && n.value.trim().length < 2) candidato = n;
        var pr = root.querySelector('[data-pro-gate-albo-prov]');
        if (!candidato && pr && !pr.value) candidato = pr;
      } else {
        var p = root.querySelector('[data-pro-gate-piva]');
        if (p && (!p.value.trim() || p.getAttribute('aria-invalid') === 'true')) candidato = p;
      }
      var chk = root.querySelector('[data-pro-gate-check]');
      if (!candidato && chk && !chk.checked) candidato = chk;
      /* solo campi VISIBILI nella qualifica corrente; fallback: primo invalid nativo visibile */
      if (candidato && !visibile(candidato)) candidato = null;
      if (!candidato) {
        var inv = root.querySelector('[aria-invalid="true"]');
        if (visibile(inv)) candidato = inv;
      }
      return candidato;
    }
    function setSticky(label, blocked, aria){
      if (cta.textContent !== label) cta.textContent = label;
      if (aria) cta.setAttribute('aria-label', aria);
      else if (origAria) cta.setAttribute('aria-label', origAria);
      else cta.removeAttribute('aria-label');
      if (blocked) cta.dataset.gateBlocked = 'true';
      else delete cta.dataset.gateBlocked;
    }
    syncStickyState = function () {
      var quote = cta.getAttribute('data-quote-active') === 'true';
      var available = stickyVariantAvailable && !(mainAdd && mainAdd.dataset.variantAvailable === 'false');
      cta.disabled = !quote && !available;
      cta.setAttribute('aria-disabled', cta.disabled ? 'true' : 'false');
      if (quote) { setSticky('Preventivo', false, 'Richiedi preventivo'); return; }
      if (!available) { setSticky('N/D', false, 'Non disponibile'); return; }
      if (gateIncomplete()) { setSticky('Completa i dati', true, 'Completa i dati professionali per aggiungere al carrello'); return; }
      setSticky(addLabel(), false, 'Aggiungi al carrello');
    };
    if (mainAdd) {
      new MutationObserver(function(){ syncStickyState(); })
        .observe(mainAdd, { attributes: true, attributeFilter: ['disabled', 'data-pro-gate-complete', 'data-variant-available'] });
    }
    syncStickyState();
    cta.addEventListener('click', function (event) {
      event.preventDefault();
      if (cta.disabled) return;
      if (cta.getAttribute('data-quote-active') === 'true') {
        var quoteHref = cta.getAttribute('data-quote-href');
        if (quoteHref) window.location.href = quoteHref;
        return;
      }
      if (gateIncomplete()) {
        syncStickyState();
        var target = campoMancante();
        if (target) {
          try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          try { if (target.focus) target.focus({ preventScroll: true }); } catch (e) {}
        } else if (typeof mainForm.reportValidity === 'function') {
          mainForm.reportValidity(); /* solo se nessun campo specifico identificato */
        }
        return; /* nessun submit con gate incompleto: si guida al campo */
      }
      syncStickyState();
      if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit();
      } else {
        if (typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) return;
        mainForm.submit();
      }
    });
  }

  var bulk = document.querySelector('[data-gef-cd-bulk]');
  var stickyPrice = bar.querySelector('[data-bulk-sticky-price]');

  function formatEuro(value) {
    return '&euro;' + (Number(value) || 0).toFixed(2).replace('.', ',');
  }

  function renderStickyPrice(excl, incl) {
    if (!stickyPrice) return;
    if (priceMode === 'incl') {
      stickyPrice.innerHTML = formatEuro(incl) +
        ' <span class="gef-cd-muted">IVA incl.</span>' +
        '<small class="gef-cd-sticky-mobile__price-sub">Prezzo finale</small>';
    } else {
      stickyPrice.innerHTML = formatEuro(excl) +
        ' <span class="gef-cd-muted">IVA escl.</span>' +
        '<small class="gef-cd-sticky-mobile__price-sub">' + formatEuro(incl) + ' IVA incl.</small>';
    }
  }

  if (bulk && stickyPrice) {
    bulk.addEventListener('gef:bulk:change', function (event) {
      var detail = event.detail || {};
      if (detail.quote) {
        stickyPrice.innerHTML = '<span class="gef-cd-muted">Su preventivo</span>';
        syncCtaQuoteState(true);
        return;
      }
      var unit = parseFloat(detail.unit) || 0;
      var boxes = parseInt(detail.boxes, 10) || 1;
      var total = unit * boxes;
      var totalIncl = total * vatMultiplier;
      renderStickyPrice(total, totalIncl);
      syncCtaQuoteState(false);
    });
  }

  window.addEventListener('gef:pdp:variant-change', function (event) {
    var detail = event.detail || {};
    stickyVariantAvailable = !!detail.available;
    if (cta && cta.getAttribute('data-quote-active') !== 'true') {
      var available = !!detail.available;
      cta.disabled = !available;
      cta.setAttribute('aria-disabled', available ? 'false' : 'true');
      cta.setAttribute('aria-label', available ? 'Aggiungi al carrello' : 'Non disponibile');
      cta.textContent = available ? addLabel() : 'N/D';
    }
    if (stickyPrice && detail.price && (!cta || cta.getAttribute('data-quote-active') !== 'true')) {
      var gross = detail.price / 100;
      renderStickyPrice(gross / vatMultiplier, gross);
    }
    syncStickyState();
  });
})();
